/* mo-pvt.js: comparison article frame (sections/mo-pvt.liquid), Mattress Overstock, 2026-10-15.
   Lens chips (a radio group): show the beds the article's guidance points to for that lens, the article's own line for
   each brand, and put the first bed of each brand in the cut. Size: reprice every card from its own variants (rendered
   by Liquid into data-prices, cents) and say so in a polite live region. "Show in the cut": choose which bed of a
   brand the cut draws. Contents rail: ids on the body's H2s in order, current section marked while reading.
   No DOM writes inside a repaint; every write is guarded so the theme's body MutationObserver cannot loop. */
(function () {
  'use strict';

  function money(cents) {
    var d = cents / 100, whole = Math.round(d) === d;
    return '$' + d.toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
  }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function setHidden(el, h) { if (el && el.hidden !== h) el.hidden = h; }

  function boot(root) {
    var chips = [].slice.call(root.querySelectorAll('[data-pvt-lens]'));
    var cards = [].slice.call(root.querySelectorAll('[data-pvt-bed]'));
    var quotes = [].slice.call(root.querySelectorAll('[data-pvt-quote]'));
    var sizeSel = root.querySelector('[data-pvt-size]');
    var live = root.querySelector('[data-pvt-live]');
    var lens = root.getAttribute('data-lens');
    var pick = { a: null, b: null };

    // money in the server HTML uses the shop format; normalise the first paint to the same format the script writes
    function priceCard(card, size) {
      var map; try { map = JSON.parse(card.getAttribute('data-prices')); } catch (e) { return; }
      var row = map[size], amt = card.querySelector('[data-pvt-price]'), was = card.querySelector('[data-pvt-was]'), lab = card.querySelector('[data-pvt-sizelabel]');
      if (!row) { setText(amt, 'Not carried in ' + size); setHidden(was, true); setHidden(lab, true); card.classList.add('is-nosize'); return; }
      card.classList.remove('is-nosize');
      setText(amt, money(row[0]) + (row[2] ? '' : ''));
      if (row[1] > row[0]) { setText(was, money(row[1])); setHidden(was, false); } else setHidden(was, true);
      setText(lab, size); setHidden(lab, false);
    }

    function setSize(size, say) {
      root.setAttribute('data-size', size);
      cards.forEach(function (c) { priceCard(c, size); });
      if (say && live) setText(live, 'Prices shown for ' + size + '.');
    }

    function setPick(br, id, emit) {
      pick[br] = id;
      cards.forEach(function (c) {
        if (c.getAttribute('data-brand') !== br) return;
        var on = c.getAttribute('data-pvt-bed') === id;
        c.classList.toggle('is-picked', on);
        var b = c.querySelector('[data-pvt-pick]');
        if (b && b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
      });
      if (emit && pick.a && pick.b) root.dispatchEvent(new CustomEvent('mo-pvt:pair', { detail: { a: pick.a, b: pick.b } }));
    }

    function setLens(key, emit) {
      lens = key;
      root.setAttribute('data-lens', key);
      chips.forEach(function (c) {
        var on = c.getAttribute('data-pvt-lens') === key;
        if (c.getAttribute('aria-checked') !== String(on)) c.setAttribute('aria-checked', String(on));
        c.tabIndex = on ? 0 : -1;
      });
      var first = { a: null, b: null };
      cards.forEach(function (c) {
        var inL = (c.getAttribute('data-lenses') || '').indexOf(' ' + key + ' ') > -1, br = c.getAttribute('data-brand');
        setHidden(c, !inL);
        if (inL && !first[br]) first[br] = c.getAttribute('data-pvt-bed');
      });
      quotes.forEach(function (q) { setHidden(q, q.getAttribute('data-pvt-quote') !== key); });
      if (first.a) setPick('a', first.a, false);
      if (first.b) setPick('b', first.b, false);
      if (emit) root.dispatchEvent(new CustomEvent('mo-pvt:pair', { detail: { a: pick.a, b: pick.b } }));
      root.querySelectorAll('[data-pvt-cards]').forEach(function (r) { if (r.scrollLeft) r.scrollLeft = 0; });
    }

    chips.forEach(function (c, i) {
      c.addEventListener('click', function () { if (c.getAttribute('aria-checked') !== 'true') setLens(c.getAttribute('data-pvt-lens'), true); });
      c.addEventListener('keydown', function (e) {
        var k = e.key, j = -1;
        if (k === 'ArrowRight' || k === 'ArrowDown') j = (i + 1) % chips.length;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') j = (i - 1 + chips.length) % chips.length;
        else if (k === 'Home') j = 0;
        else if (k === 'End') j = chips.length - 1;
        if (j < 0) return;
        e.preventDefault();
        chips[j].focus();
        setLens(chips[j].getAttribute('data-pvt-lens'), true);
      });
    });

    root.querySelectorAll('[data-pvt-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = b.closest('[data-pvt-bed]');
        if (!card || card.classList.contains('is-picked')) return;
        setPick(card.getAttribute('data-brand'), card.getAttribute('data-pvt-bed'), true);
        var cut = root.querySelector('[data-pvt-cut]');
        if (cut && window.matchMedia('(max-width: 989px)').matches) {
          var r = cut.getBoundingClientRect();
          if (r.top > innerHeight || r.bottom < 0) cut.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    if (sizeSel) sizeSel.addEventListener('change', function () { setSize(sizeSel.value, true); });

    // first state from the server markup
    cards.forEach(function (c) { if (c.classList.contains('is-picked')) pick[c.getAttribute('data-brand')] = c.getAttribute('data-pvt-bed'); });
    setSize(sizeSel ? sizeSel.value : 'Queen', false);

    rail(root);
    steps(root);
    var cm = root.querySelector('#comments');
    if (cm && (location.hash === '#comments' || cm.querySelector('.pvt-comments__msg'))) cm.open = true;
    root.classList.add('is-ready');
  }

  function rail(root) {
    var prose = root.querySelector('[data-pvt-prose]'), nav = root.querySelector('[data-pvt-rail]');
    if (!prose || !nav) return;
    var hs = [].slice.call(prose.querySelectorAll('h2'));
    hs.forEach(function (h, i) { if (!h.id) h.id = 'pvt-s' + (i + 1); });
    var links = [].slice.call(nav.querySelectorAll('[data-pvt-rail-a]'));
    if (!('IntersectionObserver' in window) || !links.length) return;
    var cur = null;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) cur = e.target; });
      if (!cur) return;
      var id = cur.id;
      links.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        if (on !== a.classList.contains('is-on')) a.classList.toggle('is-on', on);
        if (on) { if (a.getAttribute('aria-current') !== 'true') a.setAttribute('aria-current', 'true'); }
        else if (a.hasAttribute('aria-current')) a.removeAttribute('aria-current');
      });
    }, { rootMargin: '-20% 0px -70% 0px' });
    hs.forEach(function (h) { io.observe(h); });
  }

  function steps(root) {
    var prose = root.querySelector('[data-pvt-prose]');
    if (!prose) return;
    var hs = [].slice.call(prose.querySelectorAll('h2'));
    root.querySelectorAll('[data-pvt-steps]').forEach(function (a) {
      var want = a.getAttribute('data-pvt-steps').trim().toLowerCase().replace(/&amp;/g, '&');
      var h = hs.filter(function (x) { return x.textContent.trim().toLowerCase() === want; })[0];
      if (h && h.id) a.setAttribute('href', '#' + h.id);
    });
  }

  function init() { document.querySelectorAll('[data-mo-pvt]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
